import { cn } from "../../utils/tailwindUtils";

/**
 * Small mark beside a lead's name in the lead list and the Timeline report:
 * the company was researched by the AI agent (trustedge research/), with its
 * fit score. Rows carry `research: {status, fit}` only for organisations with
 * the company_research feature, so nothing renders anywhere else.
 */
const LOOK = {
    completed: { icon: "🔍", cls: "border-brand-200 bg-brand-50 text-primary dark:border-brand-800 dark:bg-brand-900/20" },
    partial: { icon: "🔍", cls: "border-brand-200 bg-brand-50 text-primary dark:border-brand-800 dark:bg-brand-900/20" },
    queued: { icon: "⏳", cls: "border-gray-200 bg-gray-50 text-gray-500 dark:border-gray-600 dark:bg-gray-700/40 dark:text-gray-300" },
    running: { icon: "⏳", cls: "border-gray-200 bg-gray-50 text-gray-500 dark:border-gray-600 dark:bg-gray-700/40 dark:text-gray-300" },
    needs_review: { icon: "❓", cls: "border-amber-200 bg-amber-50 text-amber-700 dark:border-amber-800 dark:bg-amber-900/20 dark:text-amber-300" },
};

export function researchTitle(r) {
    if (["completed", "partial"].includes(r.status)) {
        return r.fit != null ? `AI researched · company fit ${r.fit}/100` : "AI researched (fit not scored)";
    }
    if (r.status === "needs_review") return "AI research needs the right website picked";
    return "AI research in progress";
}

export default function ResearchMark({ research, className }) {
    const look = research && LOOK[research.status];
    if (!look) return null;
    const done = ["completed", "partial"].includes(research.status);
    return (
        <span title={researchTitle(research)} aria-label={researchTitle(research)}
            className={cn("inline-flex flex-shrink-0 items-center gap-0.5 rounded-full border px-1 py-px text-[9px] font-semibold leading-none",
                look.cls, className)}>
            <span aria-hidden="true">{look.icon}</span>
            {done && research.fit != null && <span>{research.fit}</span>}
        </span>
    );
}
